<template>
  <commodity-portfolio-scenarios
    :Analytics="Analytics"
    :colorTheme="colorTheme"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    :isPrices="isPrices"
    :idChart="idChart"
    :asset="asset"
    @changeInfoTable="changeInfoTable"
    @eventOnUserShow="onUserShow"
    @onTableFormat="onHoverChart"
  />
</template>
<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import CommodityPortfolioScenarios from "./CommodityPortfolioScenarios.vue";
export default {
  components: { CommodityPortfolioScenarios },
  name: "CommodityQtyChart",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 },
    asset: { required: false, default: "commodity" }
  },
  data() {
    return {
      isPrices: false,
      idChart: "planning"
    };
  },
  methods: {
    changeInfoTable(val) {
      this.$emit("changeInfoTable", val);
    },
    onUserShow(str) {
      this.$emit("eventOnUserShow", str);
    },
    onHoverChart(val) {
      this.$emit("onTableFormat", val);
    }
  }
};
</script>
